import { Control, FormState } from 'react-hook-form'
import { View } from 'react-native'
import { StyleSheet } from 'react-native-unistyles'

import FormFieldText from '@/components/form/FormFieldText'
import { FosterForm } from '@/components/fosters/fosterFormSchema'
import Card from '@/components/shared/Card'
import FosterService from '@/services/fosterService'

interface Props {
  control: Control<FosterForm, any>
  disabled: boolean
  formState: FormState<FosterForm>
  fosterId: string
}

const FosterNotesCard = ({ control, disabled, formState, fosterId }: Props) => {
  const { isLoading } = FosterService.useFoster(fosterId)

  return (
    <View style={styles.historyAndNotesContainer}>
      <Card title="Notes">
        <View
          style={{
            rowGap: 16,
          }}
        >
          <FormFieldText
            contentStyle={{ minHeight: 185 }}
            control={control}
            disabled={disabled}
            errors={formState.errors}
            fieldName="notes"
            isLoading={isLoading}
            keyboardType="default"
            label="Notes"
            multiline={true}
            required={false}
            style={{
              flexGrow: 1,
              height: 185,
              minWidth: 185,
            }}
          />
          <FormFieldText
            contentStyle={{ minHeight: 150 }}
            control={control}
            disabled={disabled}
            errors={formState.errors}
            fieldName="privateNotes"
            helperText="These notes will not be shown on the printout for the adopter."
            isLoading={isLoading}
            keyboardType="default"
            label="Private Notes"
            multiline={true}
            required={false}
            style={styles.textFieldContainer}
          />
        </View>
      </Card>
      <Card title="History & Training">
        <View
          style={{
            rowGap: 16,
          }}
        >
          <FormFieldText
            contentStyle={{ height: 150 }}
            control={control}
            disabled={disabled}
            errors={formState.errors}
            fieldName="history"
            helperText="Ex. Where they came from, any background info"
            isLoading={isLoading}
            keyboardType="default"
            label="History"
            multiline={true}
            required={false}
            style={styles.textFieldContainer}
          />
          <FormFieldText
            contentStyle={{ height: 150 }}
            control={control}
            disabled={disabled}
            errors={formState.errors}
            fieldName="training"
            helperText="Ex. House-trained, crate-trained, etc."
            isLoading={isLoading}
            keyboardType="default"
            label="Training"
            multiline={true}
            required={false}
            style={styles.textFieldContainer}
          />
        </View>
      </Card>
    </View>
  )
}

const styles = StyleSheet.create((theme) => {
  return {
    historyAndNotesContainer: {
      columnGap: theme.tokens.spacing[4],
      flexDirection: {
        xs: 'column',
        md: 'row',
      },
      rowGap: theme.tokens.spacing[4],
    },
    textFieldContainer: {
      flexGrow: 1,
      minWidth: 150,
    },
  }
})

export default FosterNotesCard
